// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"106":"9e491ddf","244":"dac3bb48","306":"f5c145a4","422":"8ac91a6e","522":"f6d8a5ce","914":"b6435c05"}[chunkId] + ".chunk.js";
};